import { makeGetRequest, makePostRequest } from "./makeRequest";
import appConfig from "../config/app.config";

export const getKycRewardConfigurations = async () => {
  try {
    const response = await makeGetRequest(
      appConfig.apiUrl.kycRewardConfiguration
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching KYC reward configurations:", error);
    throw error;
  }
};

export const addKycRewardConfig = async (configData) => {
  try {
    const response = await makePostRequest(
      appConfig.apiUrl.kycRewardConfiguration,
      configData
    );
    return response.data;
  } catch (error) {
    console.error("Error adding KYC reward configuration:", error);
    throw error;
  }
};
